/**
 * Enum values, mirroring DATABASE.md §2 exactly.
 *
 * API §1: enum values are English snake_case in both the API and the database;
 * display strings live in the client. `degraded` is a value, "Werkt nu niet" is
 * a label. Do not put Dutch or title-cased text in this file.
 */
export const STORE_CODES = ['ah', 'jumbo', 'lidl', 'ekoplaza', 'other'];
export const ADAPTER_HEALTH = ['ok', 'degraded', 'failed', 'unsupported'];
export const LINK_SOURCES = ['ean', 'manual'];
/**
 * ARCHITECTURE §3.1 / DATABASE §1. The column that makes "AI may act without
 * pre-approval" safe rather than reckless: it marks a row as AI-derived, and a
 * `manual` row must never be reassigned by a model.
 */
export const DATA_SOURCES = ['auto', 'confirmed', 'manual'];
/**
 * `purchases.origin` — free text in the schema, closed set in practice.
 *
 * Down to one value: `receipt` went with the receipt feature (migration 026)
 * and `manual` never had a writer, so check-off is the only thing that records
 * a purchase. Kept as a list rather than collapsed to a string, because the
 * column is what a second writer would have to declare itself in.
 */
export const PURCHASE_ORIGINS = ['checkoff'];
/**
 * DATABASE §12. The tables a client pulls and pushes. Append-only tables
 * (purchases) are deliberately absent — they never conflict and are reached
 * through their own endpoints (API §3.3).
 */
export const SYNC_TABLES = [
    'generic_products',
    'product_variants',
    'variant_attributes',
    'list_items',
    'suggestion_dismissals',
    'store_category_order',
];
export function isSyncTable(value) {
    return SYNC_TABLES.includes(value);
}
/**
 * ADAPTERS §5.2 / DATABASE §13.4. How old a shelf price may be before the API
 * reports `stale: true`. Shorter for things on an active list, because that is
 * the price someone is about to act on in a shop.
 */
export const STALE_AFTER_HOURS_ON_LIST = 48;
export const STALE_AFTER_HOURS_DEFAULT = 24 * 7;
/** G8: relative labels and calendar dates are rendered in household local time. */
export const HOUSEHOLD_TIMEZONE = 'Europe/Amsterdam';
//# sourceMappingURL=enums.js.map